import uniq from 'lodash/uniq';

/**
 * @deprecated use "ProductsType" instead
 */
export enum DeprecatedProductsTypes {
  ASSETS = 'ASSETS',
  LIABILITIES = 'LIABILITIES',
}

export enum ProductsType {
  ACCOUNT_CHECK = 'ACCOUNT_CHECK',
  TRANSACTIONS = 'TRANSACTIONS',
  INVESTMENTS = 'INVESTMENTS',
  LOANS = 'LOANS',
}

export const mapProductsToConditionalScope = (products: ProductsType[] | undefined) => {
  if (!products) {
    return '';
  }

  const conditionalScopes: string[] = [];

  if (products.includes(ProductsType.ACCOUNT_CHECK)) {
    conditionalScopes.push(
      'identities:readonly',
      'accounts.parties:readonly',
      'accounts.balances:readonly'
    );
  }

  if (products.includes(ProductsType.TRANSACTIONS)) {
    conditionalScopes.push('accounts.balances:readonly');
  }

  return uniq(conditionalScopes).join(',');
};
